import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { UserSurveyOperation } from './UserSurveyOperation';
import type { GroupId, UserId } from 'balus-common';
import { Modal } from '@framework/ui/elements';
import { Button } from '@framework/ui/atoms/Button';
import { UserSurveyForm } from './UserSurveyForm';
import { useUserSurveyForm } from './useUserSurveyForm';

type AnswerModalProps = {
  isOpen: boolean;
  onClose(): void;
  onAnswerCompleted(): void;
  groupId: string;
  userId: string;
  surveyId: string;
};

const UserSurveyAnswerModal: React.FC<AnswerModalProps> = ({
  isOpen,
  onClose,
  onAnswerCompleted,
  groupId,
  userId,
  surveyId,
}: AnswerModalProps) => {
  const handleCloseModal = async () => {
    await UserSurveyOperation.cancel(userId);

    onClose();
  };

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={handleCloseModal}
      title={'アンケートにご協力ください'}
      submitButton={<></>}
      cancelButton={<></>}
      shouldCloseOnOverlayClick={false}
    >
      <UserSurveyForm
        groupId={groupId}
        userId={userId}
        surveyId={surveyId}
        onAnswerCompleted={onAnswerCompleted}
        onCancel={handleCloseModal}
      />
    </GeneralModal>
  );
};

type ThanksModalProps = {
  isOpen: boolean;
  onClose(): void;
};

const UserSurveyThanksModal: React.FC<ThanksModalProps> = ({ isOpen, onClose }: ThanksModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mx-8" style={{ height: '320px' }}>
        <div className={'p-3 text-xl'}>アンケートにご協力ください</div>
        <div className="pt-8">
          アンケートにご協力いただきありがとうございました。ご回答いただいた内容は、今後のサービス向上に役立ててまいります。
        </div>
        <div className={'flex justify-center pt-20'}>
          <div className={'pr-2'}>
            <Button color="secondary" onClick={onClose}>
              閉じる
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

type Props = {
  currentUserId: UserId;
  groupId: GroupId;
};

export const UserSurveyModal: React.FC<Props> = ({ currentUserId, groupId }: Props) => {
  const { showSurveyForm, showThanks, surveyId, handleCloseModal, handleCloseThanksModal, handleAnswerCompleted } =
    useUserSurveyForm();

  return (
    <>
      <UserSurveyAnswerModal
        isOpen={showSurveyForm}
        groupId={groupId}
        userId={currentUserId}
        surveyId={surveyId}
        onClose={handleCloseModal}
        onAnswerCompleted={handleAnswerCompleted}
      />
      <UserSurveyThanksModal isOpen={showThanks} onClose={handleCloseThanksModal} />
    </>
  );
};
